import { motion } from "framer-motion";
import { DELIVERABLES, IMAGES } from "@/data/content";
import { SectionHead } from "@/components/landing/Categories";
import * as Icons from "lucide-react";

export const Deliverables = () => (
  <section id="deliverables" className="relative py-24 px-5 sm:px-8 bg-[#121216]">
    <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-14 items-center">
      <div>
        <SectionHead
          eyebrow="What Every Awardee Receives"
          title="Awardee Deliverables"
          sub="A curated set of honours crafted to celebrate your achievement in style."
        />
        <div className="grid sm:grid-cols-2 gap-4">
          {DELIVERABLES.map((d, i) => {
            const Icon = Icons[d.icon] || Icons.Star;
            return (
              <motion.div
                key={d.title}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.06 }}
                className="flex gap-4 p-4 rounded-xl bg-[#18181F] gold-border"
                data-testid={`deliverable-${i}`}
              >
                <div className="w-11 h-11 shrink-0 rounded-lg bg-amber-500/10 border border-amber-500/25 flex items-center justify-center">
                  <Icon className="w-5 h-5 text-amber-400" strokeWidth={1.8} />
                </div>
                <div>
                  <div className="font-600 text-amber-50">{d.title}</div>
                  <div className="text-sm text-zinc-400 mt-0.5">{d.desc}</div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="relative"
      >
        <div className="rounded-3xl overflow-hidden gold-border">
          <img
            src={IMAGES.golden_award}
            alt="Award trophy"
            className="w-full h-[520px] object-cover"
          />
        </div>
        <div className="absolute -bottom-6 -left-6 bg-[#09090B] gold-border rounded-2xl px-6 py-4 gold-glow">
          <div className="font-mono-lux text-3xl gold-text font-700">4</div>
          <div className="text-xs text-zinc-400 tracking-wide">Icon Categories</div>
        </div>
      </motion.div>
    </div>
  </section>
);
